import styled from 'styled-components'

export const Container = styled.li`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const Indicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Number = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${props => props.theme.size.L};
  height: ${props => props.theme.size.L};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const Connector = styled.div`
  flex: 1;
  width: ${props => props.theme.stroke.default};
  background-color: ${props => props.theme.colors.border.default};
`

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
  padding-bottom: ${props => props.theme.spacing.sp24};
`
